// Theme variables injected by gulp
var THEME_NAME;

THEME_NAME = 'bogen';

angular.module('app.controllers').controller('FavsCtrl', ['$scope', '$rootScope', 'Table', 'APIFavoritesTable', 'APIFavorites'].append(function(self, root, Table, APIFavoritesTable, APIFavorites) {
  var cookiesName, ref, ref1, tabEls, tableName;
  tableName = 'c.fav.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  self.gridMode = true;
  self.types = [
    {
      type: 'e',
      title: 'Aussteller',
      link: 'aussteller'
    },
    {
      type: 's',
      title: 'Programm',
      link: 'programm'
    },
    {
      type: 'n',
      title: 'Neuheiten',
      link: 'neuheiten'
    }
  ];
  self.typeIndex = 0;
  self.setType = function(typeIndex) {
    self.typeIndex = typeIndex;
    self.favs.params.entry_type = self.types[typeIndex].type;
    return self.page = 1; // Reset page counter when switching between favorite types
  };
  self.favs = Table({
    name: tableName,
    type: "partial",
    resource: APIFavoritesTable,
    cookies: false,
    params: {
      limit: 12,
      orderby: "title",
      entry_type: "e",
      favs: true,
      shortcode: ((ref1 = root.user) != null ? ref1.shortcode : void 0) || root.tuser || 'default'
    }
  });
  self.page = 1;
  self.loadMore = function() {
    var params;
    if (self.page >= self.favs.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.favs.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIFavorites.query(params, function(data) {
      self.more = data;
      self.favs.data.display = self.favs.data.display.concat(self.more);
      return self.moreLoad = false;
    });
  };
  root.$on('forceFavs', function(event) {
    return self.favs.reload();
  });
  tabEls = document.querySelectorAll('button[data-bs-toggle="tab"]');
  return tabEls.forEach(function(tabEl, ind) {
    return tabEl.addEventListener('shown.bs.tab', function(event) {
      self.setType(ind);
      return self.$applyAsync();
    });
  });
}));
